import { render, staticRenderFns } from "./IncomeSourceProofsDocument.vue?vue&type=template&id=05e3a9c4&"
import script from "./IncomeSourceProofsDocument.vue?vue&type=script&lang=js&"
export * from "./IncomeSourceProofsDocument.vue?vue&type=script&lang=js&"
import style0 from "./IncomeSourceProofsDocument.vue?vue&type=style&index=0&id=05e3a9c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports